export default __webpack_public_path__ + "static/media/RightArrowIcon.f0ca6f8e.svg";